import { render, staticRenderFns } from "./CompanyJournalPattern.vue?vue&type=template&id=5c97c0b4&"
import script from "./CompanyJournalPattern.vue?vue&type=script&lang=js&"
export * from "./CompanyJournalPattern.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports